import * as React from 'react';
import { Col, Row } from 'reactstrap';
import Container from 'reactstrap/lib/Container';
import './ProductButtons.css';

export interface IProductButtonsProps {
    image_path: string;
    product_list: any;
    colors: any;
}

export const ProductButtons = (props: IProductButtonsProps) => (
    <div style={{ margin: 20 }}>
        <Container
            className='ProductListContainer'
        >
            <Row>
                {props.product_list.items.map((p: any, i: number) => (
                    <Col md={6} lg={4} key={i}>
                        <a href={`#${p.hash}`} style={{ cursor: 'pointer', textDecoration: 'none' }} className='ProductButton'>
                            <Row className='d-flex align-items-center p-2 m-1'>
                                <Col xs={4} className='d-flex justify-content-center'>
                                    <img src={props.image_path + p.image} style={{ width: 'auto', height: 130 }} />
                                </Col>
                                <Col xs={8} className='d-flex flex-column ProductButtonTitle' style={{
                                    color: props.colors.primary,
                                    fontSize: 20,
                                    fontWeight: 'bold',
                                    textShadow: '-1px -1px 5px #fff, 1px -1px 5px #fff, 1px 1px 5px #fff, -1px 1px 5px #fff',
                                    userSelect: 'none'
                                }}>
                                    <div>{p.name}</div>
                                    <div style={{ fontSize: 16 }} className='ProductButtonSubtitle'>{p.code}</div>
                                </Col>
                            </Row>
                        </a>
                    </Col>
                ))}
            </Row>
        </Container>
    </div>
);


// WEBPACK FOOTER //
// ./src/pages/Home/ProductButtons/index.tsx